import type React from 'react';
import { BrowserRouter, StaticRouter } from 'react-router';
import type { PropsWithChildren } from 'react';
import { window } from '../../../js/globals';

const SsrRouter: React.FC<PropsWithChildren> = ({ children }) => {
  if (window) {
    return <BrowserRouter>{children}</BrowserRouter>;
  }
  return <StaticRouter location="">{children}</StaticRouter>;
};

export default SsrRouter;
